<div class="container">
  <div
    class="row d-flex justify-content-between align-items-baseline align-content-center"
  >
    <app-pagetitle [title]="title"></app-pagetitle>
    <mat-form-field>
      <mat-label>Select a date range</mat-label>
      <mat-date-range-input
        [formGroup]="riskAnalysisDateRange"
        [rangePicker]="picker"
      >
        <input
          matStartDate
          formControlName="start"
          placeholder="Start date"
          (focus)="picker.open()"
          readonly
        />
        <input
          matEndDate
          formControlName="end"
          placeholder="End date"
          (focus)="picker.open()"
          readonly
          (ngModelChange)="onDateRangeChange()"
        />
      </mat-date-range-input>
      <button
        *ngIf="riskAnalysisDateRange && riskAnalysisDateRange.value.start"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        matTooltip="Clear date"
        (click)="onClearDateRangeClick()"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>

      <mat-error
        *ngIf="
          riskAnalysisDateRange.controls.start.hasError('matStartDateInvalid')
        "
        >Invalid start date
      </mat-error>
      <mat-error
        *ngIf="riskAnalysisDateRange.controls.end.hasError('matEndDateInvalid')"
        >Invalid end date
      </mat-error>
    </mat-form-field>
  </div>
  <div class="row">
    <div class="col-sm-4 col-md-3">
      <app-stat
        title="Total Fuel Savings"
        class="pointer"
        [value]="
          riskAnalysisResponse ? riskAnalysisResponse.totalFuelSavings : '-'
        "
        icon="total-fuel-savings-icon"
      ></app-stat>
    </div>
    <div class="col-sm-4 col-md-3">
      <app-stat
        [title]="'CO2 Emission'"
        class="pointer"
        [value]="riskAnalysisResponse ? riskAnalysisResponse.co2Emission : '-'"
        icon="co2-emission-icon"
      ></app-stat>
    </div>
    <div class="col-sm-4 col-md-3">
      <app-stat
        title="Total Trips"
        class="pointer"
        [value]="riskAnalysisResponse ? riskAnalysisResponse.totalTrips : '-'"
        icon="total-trips-icon"
      ></app-stat>
    </div>

    <div class="col-sm-4 col-md-3">
      <app-stat
        [title]="'Total Distance Driven'"
        class="pointer"
        [value]="
          riskAnalysisResponse ? riskAnalysisResponse.totalDistanceDriven : '-'
        "
        icon="total-distance-icon"
      ></app-stat>
    </div>
    <div class="col-sm-4 col-md-3">
      <app-stat
        [title]="'Total Safe KMs'"
        class="pointer"
        [value]="riskAnalysisResponse ? riskAnalysisResponse.totalSafeKm : '-'"
        icon="safekm-icon"
      ></app-stat>
    </div>
    <div class="col-sm-4 col-md-3">
      <app-stat
        [title]="'Safety Score'"
        class="pointer"
        [value]="
          riskAnalysisResponse ? riskAnalysisResponse.safetyScore + '%' : '-'
        "
        icon="safety-score-icon"
      ></app-stat>
    </div>
    <div class="col-sm-4 col-md-3">
      <app-stat
        [title]="'Wallet Balance'"
        class="pointer"
        [value]="
          riskAnalysisResponse ? riskAnalysisResponse.walletBalance : '-'
        "
        icon="wallet-icon"
      ></app-stat>
    </div>
    <div class="col-sm-4 col-md-3">
      <app-stat
        [title]="'Improvement Plan'"
        subtitle="Number of Driving Alerts"
        class="pointer"
        [value]="
          riskAnalysisResponse ? riskAnalysisResponse.drivingAlertsCount : '-'
        "
        [routerLink]="['../', 'driving-alerts-analysis']"
        [queryParams]="{ customerName: customerName }"
        icon="improvement-icon"
      ></app-stat>
    </div>
  </div>
  <!-- <div class="row d-flex justify-content-center mb-3">
    <div class="col-sm-3">
      <button mat-button *ngIf="riskAnalysisResponse" class="btn  btn-block"
              [ngClass]="riskAnalysisResponse.totalSafeTripsPercentage>=60?
              'btn-success': riskAnalysisResponse.totalSafeTripsPercentage<60&&riskAnalysisResponse.totalSafeTripsPercentage>=30?'btn-warning':'btn-danger'">
        RISK STATUS: {{riskAnalysisResponse.totalSafeTripsPercentage >= 60 ?
        'LOW' : riskAnalysisResponse.totalSafeTripsPercentage < 60 && riskAnalysisResponse.totalSafeTripsPercentage >= 30 ? 'MODERATE' : 'HIGH'}}
      </button>
    </div>
  </div>
  <div class="row d-flex align-content-stretch flex-wrap">
    <div class=" col-md-6 pr-md-2">
      <div class="card col-12 h-100" style="max-height: 367px !important;">
        <div class="card-body" *ngIf="tripAnalysis">
          <h4 class="card-title text-center">Trip Analysis</h4>

          <apx-chart dir="ltr" class="apex-charts" [series]="tripAnalysis.series" [chart]="tripAnalysis.chart"
                     [legend]="tripAnalysis.legend" [colors]="tripAnalysis.colors"
                     [labels]="tripAnalysis.labels"
                     [dataLabels]="tripAnalysis.dataLabels" [plotOptions]="tripAnalysis.plotOptions">
          </apx-chart>
          <div class="row" style="max-height: 24px">
            <div class="col-4">
              <div class="text-center mt-4">
                <p class="mb-2 text-truncate"><i class="mdi mdi-circle text-success font-size-10 mr-1"></i> Safe Trips
                </p>
              </div>
            </div>
            <div class="col-4">
              <div class="text-center mt-4">
                <p class="mb-2 text-truncate"><i class="mdi mdi-circle text-warning font-size-10 mr-1"></i> Unsafe Trips
                </p>
              </div>
            </div>

            <div class="col-4">
              <div class="text-center mt-4">
                <p class="mb-2 text-truncate"><i class="mdi mdi-circle text-danger font-size-10 mr-1"></i> Critical
                  Trips
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 pr-0 pl-md-4" style="max-height: 367px !important;">
      <div class="card col-12  h-100">
        <div class="card-body pl-0 pr-0" *ngIf="kmsAnalysis">
          <h4 class="card-title  text-center">KMs Analysis</h4>

          <apx-chart dir="ltr" class="apex-charts h-auto" [series]="kmsAnalysis.series" [chart]="kmsAnalysis.chart"
                     [legend]="kmsAnalysis.legend" [colors]="kmsAnalysis.colors"
                     [labels]="kmsAnalysis.labels"
                     [dataLabels]="kmsAnalysis.dataLabels" [plotOptions]="kmsAnalysis.plotOptions">
          </apx-chart>
          <div class="row" style="max-height: 24px">
            <div class="col-6">
              <div class="text-center mt-2">
                <p class="mb-2 text-truncate"><i class="mdi mdi-circle text-success font-size-10 mr-1"></i> Safe Kms
                </p>
              </div>
            </div>
            <div class="col-6">
              <div class="text-center mt-2">
                <p class="mb-2 text-truncate"><i class="mdi mdi-circle text-warning font-size-10 mr-1"></i> Unsafe Kms
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div class="table-responsive mt-3">
    <table
      class="table table-centered datatable dt-responsive nowrap"
      style="border-collapse: collapse; border-spacing: 0; width: 100%"
    >
      <thead class="thead-light">
        <tr>
          <th>S.No.</th>
          <th>Start Location</th>
          <th>Destination</th>
          <th>Safety Score</th>
          <th>Fuel Savings</th>
          <th>CO2 Emission</th>
          <th>Mileage(km/l)</th>
          <th>Fuel Economy Insights</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of userTrips; let i = index">
          <td>{{ i + 1 }}</td>
          <td>
            <a
              href="javascript:void(0)"
              class="text-primary"
              [routerLink]="['../', 'trips', 'map', item.userTripId]"
              >{{ processLocationName(item.startLocationName) }}</a
            >
          </td>
          <td>
            <a
              href="javascript:void(0)"
              class="text-primary"
              [routerLink]="['../', 'trips', 'map', item.userTripId]"
              >{{ processLocationName(item.destinationName) }}</a
            >
          </td>
          <td>{{ item.safetyScore | number : "1.2-2" }}%</td>
          <td>{{ item.tripSavedAmount | number : "1.2-2" }}</td>
          <td>{{ item.co2Emission }}</td>
          <td>{{ item.mileage }}</td>
          <td>{{ item.potentialSavingLossForTheTrip ||'-' }}{{"   "}}
            <i *ngIf="item.potentialSavingLossForTheTrip" [matTooltip]="'Driver could have saved Rupsee: ' + item.potentialSavingLossForTheTrip" class="fa fa-info-circle" aria-hidden="true"></i>
          </td>
        </tr>
      </tbody>
    </table>
    <mat-paginator
      (page)="pageEvent = getServerData($event)"
      [length]="totalRecords"
      [pageSize]="search.size"
      [pageSizeOptions]="[5, 10, 15]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
